// src/pages/produtos/marcas/MarcaCad.js
import React, { useState, useEffect } from 'react';

import { IoIosSave } from "react-icons/io";
import MarcaSearch from './MarcaSearch';
import { Marca } from '../../../models/produtos/Marca';
import { useMarca } from '../../../contexts/produtos/MarcaContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const MarcaCad = ({ show, onHide }) => {
    const { marcas, addMarca, updateMarca, deleteMarca } = useMarca();
    const [marca, setMarca] = useState(new Marca());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);
    const [isSaving, setIsSaving] = useState(false); // <- novo estado para controle do botão

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setMarca(new Marca());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma Marca para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!marca?.id) {
            showMessage("Selecione uma Marca para excluir!");
        } else {
            const resposta = await showYesNo("Deseja excluir a marca selecionada?");
            if (resposta) {
                await deleteMarca(marca.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!marca.descricao) {
                showMessage("Informe uma descrição para a marca!");
                return;
            }

            setIsSaving(true); // desativa o botão

            if (!marca.id) {
                await addMarca(marca);
            } else {
                await updateMarca(marca);
            }

            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
            showMessage("Erro ao gravar dados!");
        } finally {
            setIsSaving(false); // reativa o botão após salvar
        }
    };

    const handleExit = () => {
        const marcaSel = marcas.find(c => c.id.toString() === marca?.id?.toString());
        if (marcaSel) {
            setMarca(marcaSel);
            handleEditar(marca?.id);
        } else {
            setMarca(new Marca());
        }
    };

    const handleSelectMarca = (marcaSel) => {
        setMarca(marcaSel);
        setShowSearchModal(false);
        if (marcaSel) {
            handleEditar(marcaSel.id);
        } else {
            setMarca(new Marca());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Nova Marca' : 'Alterar Marca'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={marca.id || ''}
                            onChange={(e) => setMarca({ ...marca, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />

                        <Input
                            label="Descrição"
                            value={marca?.descricao || ''}
                            onChange={(e) => setMarca({ ...marca, descricao: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton
                        type='button'
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={isSaving} // botão desativado enquanto salva
                     action="save">
                        {isSaving ? 'Salvando...' : <>Salvar <IoIosSave /></>}
                    </ModalActionButton>

                    <ModalActionButton
                        type='button'
                        className="btn btn-danger"
                        onClick={handleDelete}
                        disabled={novoReg}
                     action="delete">
                        Excluir
                    </ModalActionButton>

                    <ModalActionButton
                        type='button'
                        className="btn btn-secondary"
                        onClick={handleNovo}
                        disabled={novoReg}
                     action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <MarcaSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectMarca={handleSelectMarca}
            />
        </ModalContainer>
    );
};

export default MarcaCad;
